import { KIND_COURSE, KIND_FOLDER } from './search-index'

// What each node datatype is to search, per area. Content's map is the
// viewer's (NodeSearchSource.KindForDataType, pinned by the conformance
// file's kindCases): CATEGORY is a folder, COURSE a course, STREAMING_VIDEO a
// course that says "Video". Templates and the Asset Library map their own
// datatypes the same way: an item is a "course" (the Course boost and the
// first type chip), its folder a folder.
export const CONTENT_KINDS = {
  CATEGORY: { kind: KIND_FOLDER, label: 'Folder' },
  COURSE: { kind: KIND_COURSE, label: 'Course' },
  STREAMING_VIDEO: { kind: KIND_COURSE, label: 'Video', video: true }
}

export const TEMPLATE_KINDS = {
  COURSE_TEMPLATE_CATEGORY: { kind: KIND_FOLDER, label: 'Folder' },
  COURSE_TEMPLATE: { kind: KIND_COURSE, label: 'Template' }
}

export const LIBRARY_KINDS = {
  NODE_LIBRARY_CATEGORY: { kind: KIND_FOLDER, label: 'Folder' },
  NODE_LIBRARY: { kind: KIND_COURSE, label: 'Library item' }
}

const UNKNOWN = { kind: KIND_FOLDER, label: 'Folder' }

// Anything a map doesn't name is a folder (the viewer's least surprising
// default).
export const kindFor = (kinds, dataType) => kinds[(dataType || '').toUpperCase()] || UNKNOWN
